// Port of webapp/src/pages/loginPage.tsx (email/password branch only — the
// Mattermost SSO and signup-link branches are not reproduced).

import {FormEvent, ReactElement, useEffect, useState} from 'react'
import {Link, Navigate, useNavigate} from 'react-router-dom'
import {useUsers} from '../store/users'
import {onLoggedIn} from '../store/initialLoad'
import {Constants} from '../common/constants'
import {useTeams} from '../store/teams'

export default function LoginPage(): ReactElement {
    const navigate = useNavigate()
    const login = useUsers((state) => state.login)
    const [username, setUsername] = useState(Constants.demoAccount.username)
    const [password, setPassword] = useState(Constants.demoAccount.password)
    const [error, setError] = useState('')
    const [busy, setBusy] = useState(false)

    const submit = async (event: FormEvent): Promise<void> => {
        event.preventDefault()
        setBusy(true)
        setError('')
        const ok = await login(username.trim(), password)
        if (!ok) {
            setError('用户名或密码错误。')
            setBusy(false)
            return
        }
        const teamId = await onLoggedIn()
        navigate(teamId ? `/team/${teamId}` : '/', {replace: true})
    }

    const loggedIn = useUsers((state) => state.loggedIn)
    const teamId = useTeams((state) => state.activeTeamId)

    useEffect(() => {
        // bootstrap() already signed in; arriving here via a bookmark should not
        // show a form, so bounce to the workspace.
        if (loggedIn && teamId) {
            navigate(`/team/${teamId}`, {replace: true})
        }
    }, [loggedIn, navigate, teamId])

    if (loggedIn && teamId) {
        return <Navigate to={`/team/${teamId}`} replace/>
    }

    return (
        <div className='flex h-full items-center justify-center bg-main-bg px-4'>
            <div className='w-full max-w-[380px]'>
                <div className='mb-6 flex items-center gap-2'>
                    <span className='text-2xl' aria-hidden={true}>📋</span>
                    <span className='text-xl font-bold'>项目看板</span>
                    <span className='ml-auto text-xs opacity-50'>版本 {Constants.versionString}</span>
                </div>

                <form onSubmit={submit} className='space-y-4'>
                    <div>
                        <label className='mb-1 block text-xs font-semibold uppercase opacity-60' htmlFor='username'>用户名</label>
                        <input
                            id='username'
                            className='w-full rounded border border-main-fg/20 bg-transparent px-3 py-2 outline-none focus:border-button-bg'
                            value={username}
                            autoComplete='username'
                            onChange={(event) => setUsername(event.target.value)}
                        />
                    </div>
                    <div>
                        <label className='mb-1 block text-xs font-semibold uppercase opacity-60' htmlFor='password'>密码</label>
                        <input
                            id='password'
                            type='password'
                            className='w-full rounded border border-main-fg/20 bg-transparent px-3 py-2 outline-none focus:border-button-bg'
                            value={password}
                            autoComplete='current-password'
                            onChange={(event) => setPassword(event.target.value)}
                        />
                    </div>

                    {error && <div className='rounded bg-[#d8002e]/10 px-3 py-2 text-sm text-[#d8002e]'>{error}</div>}

                    <button type='submit' className='Button Button--primary w-full' disabled={busy}>
                        {busy ? '登录中……' : '登录'}
                    </button>
                </form>

                <div className='mt-4 flex items-center justify-between text-sm opacity-70'>
                    <Link to='/register'>注册账号</Link>
                    <span>
                        演示账号：<code className='rounded bg-main-fg/10 px-1'>张伟 / 李娜 / 王芳 / 刘洋</code> · 密码 <code className='rounded bg-main-fg/10 px-1'>演示</code>
                    </span>
                </div>
            </div>
        </div>
    )
}
